import { createElement } from "react";
import { clsx } from "clsx";

import { toPx } from "~/utils/components";

import "./Stack.css";

import type { CommonProps } from "../components";

export interface StackProps extends CommonProps {
  align?: "stretch" | "center" | "start" | "end";
  as?:
    | "div"
    | "span"
    | "main"
    | "article"
    | "section"
    | "form"
    | "label"
    | "header"
    | "li"
    | "a";
  children?: React.ReactNode;
  direction?: "horizontal" | "vertical";
  gap?: number | string;
  justify?: "stretch" | "center" | "start" | "end" | "space-between";
}

export function Stack({
  align,
  as = "div",
  children,
  direction = "vertical",
  gap = 16,
  justify,
  style = {},
  ...rest
}: StackProps) {
  const customProperties = {
    "--stack-align": align,
    "--stack-direction": direction === "vertical" ? "column" : "row",
    "--stack-gap": typeof gap === "number" ? toPx(gap) : gap,
    "--stack-justify": justify,
  };

  return createElement(
    as,
    {
      ...rest,
      className: clsx("Stack", rest.className),
      style: { ...customProperties, ...style },
    },
    children,
  );
}
